import _ from "underscore";
import { mobileAlert, hideUnobtrusiveLoader, showUnobtrusiveLoader, showLoader, hideLoader } from "../plugins";
import { createAsyncAction } from "../utils/ajex";
import * as TYPES from "./types";
import * as RetailersApi from "../api/retailers";
import * as aj from "../aj/index";
import M from "../strings";
import * as _query from "../framework/query";
import * as responses from "../api/responses";

export const getRetailers = createAsyncAction(TYPES.GET_RETAILERS, data => {
    const query = data.query || _query.create();

    aj.dispatch({
        type: TYPES.GET_RETAILERS,
    })

    return new Promise((resolve, reject) => {
        showLoader();
        RetailersApi.getStores(query)
            .then(response => {
                getRetailers.complete({
                    retailers: response.value,
                });
                resolve();
            })
            .catch(e => {
                mobileAlert(M("ooops"), responses.msg(e), "error");
                getRetailers.fail();
                reject();
            })
            .finally(hideLoader);
    })
})

export const getRetailer = createAsyncAction(TYPES.GET_RETAILER, data => {
    const query = data.query || _query.create();

    aj.dispatch({
        type: TYPES.GET_RETAILER,
    })

    return new Promise((resolve, reject) => {
        showLoader();
        RetailersApi.getStoreDetails(data)
            .then(response => {
                getRetailer.complete({
                    retailer: response.value,
                });
                resolve();
            })
            .catch(e => {
                mobileAlert(M("ooops"), responses.msg(e), "error");
                getRetailer.fail();
                reject();
            })
            .finally(hideLoader);
    })
})

export const clearRetailer = aj.createAction(TYPES.CLEAR_RETAILER, data => {
    aj.dispatch({
        type: TYPES.CLEAR_RETAILER,
    })
})